export class EtatTache {

    aee_id: string;
    aee_libelle: string;
    aee_couleur: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }
        this.aee_id       = data['aee_id'] ? data['aee_id'] : null;
        this.aee_libelle  = data['aee_libelle'] ? data['aee_libelle'] : null;
        this.aee_couleur  = data['aee_couleur'] ? data['aee_couleur'] : null;
    }
}
